import React from 'react'

export const NavLeft = () => {
  return (
   <>
      <ul className='leftbar'>
            <li><a href={'https://www.instagram.com/lokesh_jangir_05'}><img className="icon-img" src="https://cdn-icons-png.flaticon.com/512/3955/3955024.png"
                        alt=""/></a>
            </li>
            <li><a href={'https://www.facebook.com/lokesh'}><img className="icon-img" src="https://cdn-icons-png.flaticon.com/512/3670/3670032.png"
                        alt=""/></a>
            </li>
            <li><a href={'https://www.linkedin.com/in/lokesh-k-64a825257'}><img className="icon-img" src="https://cdn-icons-png.flaticon.com/512/145/145807.png" alt=""/></a>
            </li>
            <li><a href={'https://github.com/deadshot002'}><img className="icon-img" src="https://cdn-icons-png.flaticon.com/512/10090/10090288.png"
                        alt=""/></a>
            </li>
            <li><a href={'https://twitter.com/Lokesh12477175?t=Gmk2gnhUNAkup1ZpJJVV-w&s=09'}><img className="icon-img" src="https://cdn-icons-png.flaticon.com/512/3670/3670151.png"
                        alt=""/></a>
            </li>
            <div className="line1"></div>
          </ul>
   </>
  )
}
